module.exports = __webpack_public_path__ + "static/img/Band_nato_blue.d7dcde8.jpg";